import React from 'react';
import { Select } from 'antd';
import { useTranslation } from '../hooks/useTranslation';

const { Option } = Select;

const LanguageSelector: React.FC = () => {
  const { t, changeLanguage, currentLanguage } = useTranslation();

  const languages = [
    { code: 'en', name: t('language.en'), flag: '🇺🇸' },
    { code: 'zh-CN', name: t('language.zh-CN'), flag: '🇨🇳' },
    { code: 'zh-HK', name: t('language.zh-HK'), flag: '🇭🇰' },
  ];

  const handleLanguageChange = (value: string) => {
    changeLanguage(value);
  };

  return (
    <Select
      value={currentLanguage}
      onChange={handleLanguageChange}
      style={{ width: 120 }}
      dropdownStyle={{ minWidth: 120 }}
    >
      {languages.map((lang) => (
        <Option key={lang.code} value={lang.code}>
          <span style={{ marginRight: 8 }}>{lang.flag}</span>
          {lang.name}
        </Option>
      ))}
    </Select>
  );
};

export default LanguageSelector; 